export type TParallaxBounds = {
  topPosition: number;
  bottomPosition: number;
};

export type TParallaxTranslateParams = {
  scrollY: number;
  topPosition: number;
  bottomPosition: number;
  containerHeight: number;
  viewportHeight: number;
  backgroundMaxHeight: number;
};

/** Границы скролла, в которых активен эффект параллакса. */
export const calculateParallaxBounds = (
  absoluteTop: number,
  containerHeight: number,
  viewportHeight: number,
): TParallaxBounds => ({
  bottomPosition: absoluteTop + containerHeight,
  topPosition: absoluteTop - viewportHeight,
});

/**
 * Считает смещение фона в px. Возвращает `null`, если скролл вне зоны параллакса —
 * в этом случае transform нужно сбросить.
 */
export const calculateParallaxTranslate = ({
  scrollY,
  topPosition,
  bottomPosition,
  containerHeight,
  viewportHeight,
  backgroundMaxHeight,
}: TParallaxTranslateParams): number | null => {
  if (scrollY <= topPosition || scrollY >= bottomPosition) {
    return null;
  }

  const bgOffset = (scrollY - topPosition) / (viewportHeight + backgroundMaxHeight);

  return Math.round(bgOffset * (containerHeight - backgroundMaxHeight));
};
